import {
  dictionariesListViewTranslation,
  DictionariesListViewTranslation,
} from '@/assets/locales/views/dictionaries/list/dictionariesListView.translation.pl.ts';

export type DictionariesViewTranslation = {
  list: DictionariesListViewTranslation;
};

export const dictionariesViewsTranslation: DictionariesViewTranslation = {
  list: dictionariesListViewTranslation,
};
